/**
 * This is Josep V creation to compare objects to make sure Hydration is possible
 * @param hydratedInitialState
 * @param initialState
 * @returns Boolean
 */
const isOkForHydration = (hydratedInitialState, initialState):boolean =>
    JSON.stringify(Object.keys(hydratedInitialState).sort()) !== JSON.stringify(Object.keys(initialState).sort())

export default isOkForHydration